import React from 'react';

import Layout from '../../../components/Layout';
import Loginform from './LoginForm';

import './css/signin.css';

export default function Login(props) {
  return (
    <Layout {...props}>
      <div className="field">
        <div className="signinField">
          <div className="signIn">
            <div className="signHead">
              <h1>-SIGN IN-</h1>
            </div>
            <div className="signInForm">
              <Loginform />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
